import {
  BtnClasses,
  DropDownMenu,
  type DropDownOption,
  IconButton,
} from '@tcweb/connect-ui';
import { t } from '@trimble/i18n';
import { DropdownSelect } from '@trimble/ui-components/solidjs';
import { Component, Show } from 'solid-js';

import { FX_REFERENCES_FILTER_OPTIONS } from '../selections/tree/filter-fx-reference-nodes';
import { fxWorkspaceDropdownSlotClass } from './fx-workspace-dropdown-slot-class';
import type {
  WorkspacesTabHeaderControlsProps,
  WorkspacesTabWorkspaceActionsProps,
} from './WorkspacesTabHeaderControls.types';

export const WorkspacesTabReferencesFilter: Component<
  Pick<
    WorkspacesTabHeaderControlsProps,
    'referencesFilterMode' | 'onReferencesFilterChange'
  >
> = (props) => (
  <div
    class={fxWorkspaceDropdownSlotClass}
    data-testid="fx-references-filter-dropdown"
    aria-label={t('mobileMapping.fxWorkspace.references.filter.label')}
  >
    <DropdownSelect
      options={FX_REFERENCES_FILTER_OPTIONS()}
      value={props.referencesFilterMode}
      onValueChange={props.onReferencesFilterChange}
    />
  </div>
);

export const WorkspacesTabReferencesViewToggle: Component<
  Pick<
    WorkspacesTabHeaderControlsProps,
    | 'referencesViewToggleIcon'
    | 'referencesViewToggleTitle'
    | 'onReferencesViewToggle'
  >
> = (props) => (
  <IconButton
    color={BtnClasses.TERTIARY}
    icon={props.referencesViewToggleIcon}
    size="icon-medium"
    data-testid="fx-references-view-toggle"
    title={props.referencesViewToggleTitle}
    clicked={props.onReferencesViewToggle}
  />
);

const WorkspaceActionsMenu: Component<
  Pick<
    WorkspacesTabWorkspaceActionsProps,
    'onModifyWorkspaceData' | 'onNewExtraction' | 'onDeleteWorkspace'
  >
> = (props) => {
  const actions = (): { option: DropDownOption; run(): void }[] => [
    {
      option: {
        text: t('mobileMapping.fxWorkspace.extraction.newExtraction'),
        testId: 'new-extraction-option',
      },
      run: props.onNewExtraction,
    },
    {
      option: {
        text: t('mobileMapping.fxWorkspace.modifyWorkspaceData'),
        testId: 'modify-workspace-data-option',
      },
      run: props.onModifyWorkspaceData,
    },
    {
      option: {
        text: t('mobileMapping.fxWorkspace.delete'),
        testId: 'delete-workspace-option',
      },
      run: props.onDeleteWorkspace,
    },
  ];

  return (
    <div data-testid="workspace-actions-menu">
      <DropDownMenu
        anchorIcon="tc-icon-content-add"
        iconTooltip={t('mobileMapping.fxWorkspace.workspaceActions')}
        dataCy="workspace-actions-menu-button"
        position="right"
        optionsType="both"
        dropDownOptions={actions().map((action) => action.option)}
        onSelectionChanged={(_text, index) => actions()[index]?.run()}
      />
    </div>
  );
};

export const WorkspacesTabWorkspaceActions: Component<
  WorkspacesTabWorkspaceActionsProps
> = (props) => (
  <Show when={props.hasActiveWorkspace}>
    <WorkspaceActionsMenu
      onModifyWorkspaceData={props.onModifyWorkspaceData}
      onNewExtraction={props.onNewExtraction}
      onDeleteWorkspace={props.onDeleteWorkspace}
    />
  </Show>
);
